import { createBindingEditorState } from './BindingEditorState.js';

/**
 * BindingEditorStateManager
 *
 * Owns the lifecycle — creation, lookup, removal, cleanup — of
 * BindingEditorState instances, one per binding (keyed by binding.id).
 * Callers (StateBindingsTable.vue) only ever call get()/remove()/clear();
 * the lookup Map itself is not exposed.
 *
 * Manages transient editor state only. Never references
 * AutomationBinding, generators, migration, or project serialization —
 * see BindingEditorState.js for what it actually holds.
 *
 * @returns {{
 *   get: (bindingId: string) => object,
 *   remove: (bindingId: string) => void,
 *   clear: () => void,
 * }}
 */
export function createBindingEditorStateManager() {
  const states = new Map(); // bindingId -> BindingEditorState

  return {
    /** Returns this binding's BindingEditorState, creating it on first request. */
    get(bindingId) {
      if (!states.has(bindingId)) states.set(bindingId, createBindingEditorState());
      return states.get(bindingId);
    },

    /** Drops a binding's state — call when its binding is removed. */
    remove(bindingId) {
      states.delete(bindingId);
    },

    /** Drops all managed state. */
    clear() {
      states.clear();
    },
  };
}
